import { Link } from "react-router-dom";
import { ShoppingBag, Star } from "lucide-react";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product, 1);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group block"
      data-testid={`product-card-${product.slug}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative overflow-hidden bg-[#F3EFEA] rounded-md aspect-[4/5] mb-4 hover-lift-img">
        <img
          src={product.images[0]}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 flex flex-col gap-1.5 items-start">
          {product.is_new && (
            <span className="bg-[#1A1A1A] text-[#FDFBF7] text-[10px] tracking-widest-plus uppercase px-2.5 py-1 rounded-full">
              New
            </span>
          )}
          {product.original_price && product.original_price > product.price && (
            <span className="bg-[#D27D60] text-[#FDFBF7] text-[10px] tracking-widest-plus uppercase px-2.5 py-1 rounded-full">
              Save {Math.round((1 - product.price / product.original_price) * 100)}%
            </span>
          )}
          {product.is_featured && !product.is_new && (
            <span className="bg-[#FDFBF7] text-[#1A1A1A] border border-[#1A1A1A] text-[10px] tracking-widest-plus uppercase px-2.5 py-1 rounded-full">
              ★ Bestseller
            </span>
          )}
          {product.stock > 0 && product.stock <= 5 && (
            <span className="bg-[#FEF3C7] text-[#92400E] text-[10px] tracking-widest-plus uppercase px-2.5 py-1 rounded-full border border-[#F59E0B]/30">
              Only {product.stock} left
            </span>
          )}
          {product.stock === 0 && (
            <span className="bg-[#9BA595] text-[#FDFBF7] text-[10px] tracking-widest-plus uppercase px-2.5 py-1 rounded-full">
              Sold out
            </span>
          )}
        </div>
        <button
          onClick={handleAdd}
          className="absolute bottom-3 right-3 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 bg-[#1A1A1A] text-[#FDFBF7] rounded-full px-4 py-2.5 text-xs uppercase tracking-widest-plus flex items-center gap-2 transition-all duration-300 hover:bg-[#D27D60]"
          data-testid={`product-card-add-${product.slug}`}
        >
          <ShoppingBag className="w-3.5 h-3.5" strokeWidth={1.5} />
          Add
        </button>
      </div>
      <div className="px-1">
        <div className="flex items-center gap-1 mb-1.5">
          <Star className="w-3 h-3 fill-[#D27D60] text-[#D27D60]" />
          <span className="text-xs text-[#9BA595]">{product.rating.toFixed(1)} · {product.review_count} reviews</span>
        </div>
        <h3 className="font-serif-display text-xl leading-tight mb-1 group-hover:text-[#D27D60] transition-colors">
          {product.name}
        </h3>
        <p className="text-xs text-[#666] mb-2 line-clamp-1">{product.short_description}</p>
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">₹{product.price}</span>
          {product.original_price && (
            <span className="text-xs text-[#9BA595] line-through">₹{product.original_price}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
